import { ReadAdminDashboardStakeType } from '@/types';
import { Tables } from '../pools/table/Tables';
import { GridColDef } from '@mui/x-data-grid';
import { UserDashboardStakeListTableColumns } from '../pools/table/ColumnsData';
import { Button, Typography } from '@mui/material';
import { now } from '@/lib/dayjs';
import { fontWeight } from '@/theme';

export default function StakeList({ list }: { list: ReadAdminDashboardStakeType[] | undefined }) {
  if (!list) {
    return <>stake empty</>;
  }
  const addUserDashboardStakeListTableColumns: GridColDef[] = [
    ...UserDashboardStakeListTableColumns,
    {
      minWidth: 200,
      field: 'shortTxHash',
      headerName: 'hash',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" onClick={() => handleButtonClick(params.row.hash)}>
          {params.row.shortTxHash}
        </Button>
      ),
    },
  ];

  const handleButtonClick = (aData: string) => {
    const src =
      process.env.NODE_ENV === 'development'
        ? `https://amoy.polygonscan.com/tx/${aData}`
        : `https://polygonscan.com/tx/${aData}`;
    window.open(src);
  };
  return (
    <>
      <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="left">
        Stake
      </Typography>
      {<Tables list={list} columns={addUserDashboardStakeListTableColumns} csvName={`stake-${now()}`} />}
    </>
  );
}
